export enum AriaLabel {
    CLOSE = 'Lightbox schließen',
}
